import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import style from './css/Style.css'; 

// import pour la personnalisation du theme
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { styledTheme } from "./asset/theme";
import { CssBaseline } from "@mui/material";

const theme = createTheme(styledTheme);
console.log(theme);
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <App />
  </ThemeProvider>
);
